/* Posizione della galleria e totale del pulsante, limitati alla sezione prodotto. */
(() => {
  'use strict';
  if (window.taibiPdpUiLoaded) return;
  window.taibiPdpUiLoaded = true;

  const mobile = window.matchMedia('(max-width: 989px)');

  function positionGallery(pdp) {
    const slot = pdp.querySelector('[data-taibi-media-slot]');
    const gallery = pdp.querySelector('.product__media-wrapper');
    const info = pdp.querySelector('.product__info-wrapper');
    if (!gallery || !info) return;
    if (mobile.matches && slot) {
      if (gallery.parentElement !== slot) slot.appendChild(gallery);
    } else if (gallery.parentElement !== pdp) {
      pdp.insertBefore(gallery, info);
    }
  }

  function updateTotal(pdp) {
    pdp.querySelectorAll('[data-taibi-total-button]').forEach((button) => {
      const output = button.querySelector('[data-taibi-cta-total]');
      const form = button.closest('form');
      if (!output || !form) return;
      const input = Array.from(form.elements).find((element) => element.name === 'quantity');
      const quantity = Number(input ? input.value : 1);
      let price = Number(button.dataset.unitPrice);
      const valid = Number.isInteger(quantity) && quantity > 0 && Number.isFinite(price) &&
        (!input || input.type === 'hidden' || input.validity.valid);
      if (!valid) {
        output.hidden = true;
        button.removeAttribute('aria-label');
        return;
      }
      try {
        const breaks = JSON.parse(button.dataset.priceBreaks || '[]') || [];
        let minimum = 0;
        breaks.forEach((tier) => {
          const from = Number(tier.minimum_quantity);
          const amount = Number(tier.price);
          if (quantity >= from && from >= minimum && Number.isFinite(amount)) {
            price = amount;
            minimum = from;
          }
        });
      } catch (_) { /* Prezzo standard se non ci sono fasce valide. */ }
      const locale = document.documentElement.lang || 'it-IT';
      const currency = button.dataset.currency || 'EUR';
      let total;
      try {
        total = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(price * quantity / 100);
      } catch (_) {
        output.hidden = true;
        button.removeAttribute('aria-label');
        return;
      }
      output.textContent = total;
      output.hidden = false;
      const label = button.querySelector('.taibi-cta-lungo');
      if (!button.disabled && label) button.setAttribute('aria-label', `${label.textContent.trim()} · ${total}`);
      else button.removeAttribute('aria-label');
    });
  }

  function initialize(scope = document) {
    const pdps = [];
    if (scope.matches && scope.matches('[data-taibi-pdp]')) pdps.push(scope);
    scope.querySelectorAll('[data-taibi-pdp]').forEach((pdp) => pdps.push(pdp));
    pdps.forEach((pdp) => {
      positionGallery(pdp);
      if (typeof window.taibiInitGallery === 'function') window.taibiInitGallery(pdp);
      updateTotal(pdp);
    });
  }

  function syncVariant({ data }) {
    if (!data || !data.html) return;
    const section = document.getElementById(`MainProduct-${data.sectionId}`);
    const pdp = section && section.querySelector('[data-taibi-pdp]');
    if (!pdp) return;
    pdp.querySelectorAll('[data-taibi-total-button]').forEach((button) => {
      const replacement = data.html.getElementById(button.id);
      if (!replacement) return;
      ['unitPrice', 'currency', 'priceBreaks'].forEach((key) => {
        if (replacement.dataset[key] !== undefined) button.dataset[key] = replacement.dataset[key];
      });
    });
    updateTotal(pdp);
  }

  document.addEventListener('input', (event) => {
    if (!event.target.matches || !event.target.matches('input[name="quantity"]')) return;
    const pdp = event.target.closest('[data-taibi-pdp]');
    if (pdp) updateTotal(pdp);
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches || !event.target.matches('input[name="quantity"]')) return;
    const pdp = event.target.closest('[data-taibi-pdp]');
    if (pdp) updateTotal(pdp);
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:block:select', (event) => initialize(event.target.closest('product-info') || document));
  document.addEventListener('product-info:loaded', (event) => initialize(event.target));
  if (mobile.addEventListener) mobile.addEventListener('change', () => initialize());
  else mobile.addListener(() => initialize());
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, syncVariant);
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => window.setTimeout(() => initialize(), 0));
    subscribe(PUB_SUB_EVENTS.quantityUpdate, () => initialize());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
